export default __webpack_public_path__ + "97aaeb03d8d1fdc23ebe7e10878c5a77.wav";